import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import { Container, Row, Col, NavDropdown, Button } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import "./homecss/homenavtwo.css";
import { BsInstagram, BsFacebook } from "react-icons/bs";
import LocationOne from "./LocationOne";
import { usePlaces } from "../../Blc_Business/BlcHomeLandingPage/BlcHomeWindowOne";

import { useBlcNavScroll } from "../../Blc_Business/BlcHomeLandingPage/HomeWindowThree";

//HomeNavThree is a Lower Nav bar on lg screen and calls on HomeNav.

const HomeNavThreeLg = (props, history) => {
    const blcScroll = useBlcNavScroll();
    const [active, setActive] = useState('default');

    const [showMedia, setShowMedia] = useState(false);
    const [showLocations, setShowLocations] = useState(false);

    const showMediaDropdown = (e) => {
        setShowMedia(!showMedia);
    }

    const showLocDropdown = (e) => {
        setShowLocations(!showLocations);
    }

    // current page path 
    const activePage = useLocation().pathname.toLowerCase().split('/')[1];

    // hide navbar on scroll down and show on scroll up 
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
        if (lastScrollY < window.scrollY) {
            document.getElementById('homeNavTwo').classList.add('hideNav');
        }
        else {
            document.getElementById('homeNavTwo').classList.remove('hideNav');
        }
        lastScrollY = window.scrollY;
    });

    function locNameFormatting(str) {
        if (str.indexOf(' ') >= 0) {
            return str.split(' ').join('-');
        }
        else {
            return str;
        }
    }

    // Close location/media dropdown if the user clicks outside of it
    window.onclick = function (e) {
        if (!e.target.matches('#locTab')) {
            setShowLocations(false);
        }
        if (!e.target.matches('#mediaTab')) {
            setShowMedia(false);
        }
    }



    return (
        <>
            <Navbar fixed="top" style={{ transition: '3s ease', backgroundColor: '#05252f' }}>

                <Container className="nav-color" fluid>
                    <Container className="d-flex justify-content-end">
                        <div style={{ color: 'white', fontSize: '14px' }} className='mb-2'>
                            <b>Tel:</b><a className="link-color" href="tel:+88 01313407157 " rel="noopener noreferrer" target="_blank">&nbsp; {props.navDataLg[0].tel} </a> &nbsp;
                            <b>E-mail:</b><a className="link-color" href="mailto: blc.communications@brac.net" rel="noopener noreferrer" target="_blank">&nbsp; {props.navDataLg[0].mail} </a> &nbsp; &nbsp;
                            <b>Follow Us:</b>
                            <a className="social-link" href="https://www.facebook.com/BLC.BRAC" rel="noopener noreferrer" target="_blank">&nbsp;&nbsp;<BsFacebook size={18} /></a>
                            <a className="social-link" href="https://www.instagram.com/accounts/login/?next=/blc.brac/" rel="noopener noreferrer" target="_blank">&nbsp;&nbsp;<BsInstagram size={18} /></a>
                        </div>
                    </Container>
                </Container>
                <Container className="py-2" fluid>
                    {/* <Container className="py-3" fluid> */}
                    <Container>
                        <Row>
                            <Col>
                                <Link to="/">
                                    <Navbar.Brand href="#home">
                                        <img
                                            width="175"
                                            height="65"
                                            alt=""
                                            src={props.navDataLg[0].logo}
                                            className="d-inline-block align-top"
                                        />{" "}
                                    </Navbar.Brand>

                                </Link>
                            </Col>
                            <Col className="d-flex justify-content-end">
                                <Nav className="nav-text stroke"
                                    activeKey={active}
                                    onSelect={(selectedKey) => setActive(selectedKey)}>
                                    <Nav.Item className="itemTwo">
                                        <Link to="/home" className="blcnavtwo">
                                            <h6 className="homeNavtext">{props.navFeature[0].blc_feature_name}</h6>
                                        </Link>
                                    </Nav.Item>

                                    {/* <Nav.Item
                    className="itemTwo"
                    onMouseOver={() => val[1](true)}
                    onMouseLeave={() => val[1](false)}
                  >
                    <LocationOne
                      valDrop={props.navDropDown}
                      valTag={props.navFeature[1].blc_feature_name}
                      valIndex={blcIndex}
                    ></LocationOne>
                  </Nav.Item> */}
                                    <Nav.Item className="itemTwo"
                                        onClick={showLocDropdown}
                                    >
                                        <div className="blcnavtwo" style={{ cursor: 'pointer' }}>
                                            <h6 id="locTab" className="homeNavtext">Locations</h6>
                                            <NavDropdown
                                                className="media-dropdown"
                                                show={showLocations}
                                            // onMouseLeave={hideLocDropdown}
                                            // title={'Media'}
                                            >
                                                <Container>
                                                    <Row>
                                                        <Col xs={6}
                                                            className='d-flex align-items-start'
                                                        // style={{ borderRight: '1px solid lightgray', marginRight: '20px' }}
                                                        >
                                                            <h4 style={{ fontWeight: '600', width: '90%' }}>
                                                                Explore 18 <span style={{ color: '#ec008c' }}>BRAC LEARNING CENTRES</span> Across Bangladesh!
                                                            </h4>
                                                        </Col>
                                                        <Col xs={6}>
                                                            <Row className="gy-2">

                                                                {props.navDropDown.map((val, index, idx) => (

                                                                    <Col xs={3} key={Math.random()}>
                                                                        <Link to={`/locations/${locNameFormatting(val.blc_location_name)}`} >
                                                                            {" "}
                                                                            <a className="locButton" style={{ fontSize: '1rem' }}>
                                                                                {val.blc_location_name}
                                                                            </a>{" "}
                                                                        </Link>
                                                                        {/* <hr style={{ width: '100%', color: 'gray', padding: '1px' }} /> */}
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Col>

                                                    </Row>

                                                </Container>
                                            </NavDropdown>
                                        </div>
                                    </Nav.Item>

                                    {/* <Nav.Item className="itemTwo">
                    <Link to="/gallery" className="blcnavtwo">
                      <h6 className="homeNavtext">{props.navFeature[3].blc_feature_name}</h6>
                    </Link>
                  </Nav.Item> */}

                                    <Nav.Item className="itemTwo">
                                        <Link to="/facilities" className="blcnavtwo">
                                            <h6 className="homeNavtext">{props.navFeature[2].blc_feature_name}</h6>
                                        </Link>
                                    </Nav.Item>

                                    <Nav.Item className="itemTwo"
                                        onClick={showMediaDropdown}
                                    >
                                        <div className="blcnavtwo" style={{ cursor: 'pointer' }}>
                                            <h6 id="mediaTab" className={`homeNavtext ${activePage === 'allnews' ? "activePageLink" : ""}`}>Media</h6>
                                            <NavDropdown
                                                className="media-dropdown"
                                                show={showMedia}
                                            // onMouseLeave={hideMediaDropdown}
                                            // title={'Media'}
                                            >
                                                <Container>
                                                    <Row className="">
                                                        <Col lg={5} className='d-flex align-items-start'>
                                                            <h4 style={{ fontWeight: '600' }}>
                                                                Get to
                                                                <span style={{ color: '#ec008c' }}> know us better</span>
                                                            </h4>
                                                        </Col>
                                                        <Col lg={3} className='me-2'>
                                                            <Link style={{}} to='/gallery'>
                                                                <a className="media-dropdown-link" href="">Gallery</a>
                                                                <p className="dropdown-link-decription">Learn about our delivered services, culture and locations</p>
                                                            </Link>
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Link to='/allnews'>
                                                                <a className="media-dropdown-link" href="">Blogs</a>
                                                                <p className="dropdown-link-decription">Discover latest blogs, updates on our most recent activities and plans</p>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </NavDropdown>
                                        </div>
                                    </Nav.Item>
                                    {/* <Nav.Item className="itemTwo"
                    onMouseEnter={showDropdown}
                    onMouseLeave={hideDropdown}>
                    <Link to="/#" className="blcnavtwo">
                      <h6 className="homeNavtext">Media</h6>
                      <NavDropdown
                        className="media-dropdown"
                        show={show}
                      >
                        <NavDropdown.Item className="media-dropdown-item">
                          <Link to='/gallery'>
                            <a className="media-dropdown-link" href="">Gallery</a>
                          </Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item disabled className="media-dropdown-item py-0" >
                          <hr style={{ width: '100%', color: 'gray', padding: '1px' }} />
                        </NavDropdown.Item>
                        <NavDropdown.Item className="media-dropdown-item">
                          <Link to='/allnews'>
                            <a className="media-dropdown-link" href="">Blogs</a>
                          </Link>
                        </NavDropdown.Item>
                      </NavDropdown>
                    </Link>
                  </Nav.Item> */}


                                    <Nav.Item className="itemTwo">
                                        <Link to="/faq" className="blcnavtwo">
                                            <h6 className="homeNavtext">{props.navFeature[5].blc_feature_name}</h6>
                                        </Link>
                                    </Nav.Item>

                                    <Nav.Item className="itemTwo">
                                        <Link to="/contact" className="blcnavtwo">
                                            <h6 className="homeNavtext">{props.navFeature[6].blc_feature_name}</h6>
                                        </Link>
                                    </Nav.Item>

                                    <Nav.Item className="itemTwo">
                                        <Link to="/reservation" className="blcnavtwo">
                                            {/* <h6 className="homeNavtext">{props.navFeature[4].blc_feature_name}</h6> */}
                                            <Button className="button-color" style={{ padding: '2px 20px' }}>{props.navFeature[4].blc_feature_name}</Button>
                                        </Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </Navbar>
        </>
    );
};
export default HomeNavThreeLg;

